module.exports = __webpack_public_path__ + "img/rmrPower.d4cd8775.svg";